export default "__VITE_ASSET__c7891f39__"